import * as React from 'react';
export const IcDirectionsOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a9.84 9.84 0 00-4.62 1.14L13.24 9h.35l-.3-.29a1.004 1.004 0 011.42-1.42l2 2a1 1 0 010 1.42l-.88.88 5 5A9.84 9.84 0 0022 12 10 10 0 0012 2zM5 3.51A1.053 1.053 0 103.51 5l.74.73a10 10 0 0014.06 14.02l.73.74A1.04 1.04 0 0020.49 19L5 3.51zM9 13v2a1 1 0 11-2 0v-2a3.76 3.76 0 011.43-3.12l1.43 1.42A1.8 1.8 0 009 13z'
      fill='currentColor'
    />
  </svg>
);
